/* Wishlist - saves the size the customer actually chose.

   WHERE THE VARIANT COMES FROM, AND WHY IT IS NOT THE CART INPUT ALONE.
   The size grid is the source of truth for whether a size has been CHOSEN:
   `.dsg-size[aria-pressed="true"]`, which the size-grid work sets only on a
   real tap. The cart form's hidden id input always holds something - Shopify
   pre-fills it with the first available variant - so reading that alone would
   happily save a size nobody picked. On this catalogue the first variant is
   frequently a sold-out EU 35.

   That is the bug the Back in Stock app's own wishlist button has on this
   theme: choose EU 40 and it saves EU 43. It resolves the variant internally
   and ignores the attribute, so the theme cannot correct it - which is why this
   exists instead of a restyle of theirs.

   WHICH BUTTON THE HEART SITS BESIDE.
   Whichever one is the live call to action. Normally that is Add to cart; on a
   sold-out size the theme hides Add to cart and the Back in Stock app shows
   GET NOTIFIED instead. Wrapping only Add to cart left the heart alone in an
   empty 20px row underneath GET NOTIFIED, which read as a broken button.

   So the row follows the visible button and any stale row is dismantled. Where
   the row then sits on the page is dico-bis-placement.js's business, not this
   file's - see the coordination note in that file.

   WHY TIMERS AND NOT JUST AN OBSERVER. Two things must stay in step after a
   size change, and they need different mechanisms.

     - The heart ELEMENT is destroyed, because the theme replaces the whole buy
       area. A MutationObserver on childList catches that and re-mounts it.
     - The heart's pressed STATE depends on the selection, and the theme updates
       that by assigning a property and rewriting attributes inside a subtree
       that may not have moved. Assigning a .value property fires no mutation at
       all. This is the same trap that once made the product page sit there
       doing nothing for two seconds, so the state is re-read on a short cascade
       of timers after any interaction - what proved reliable there.

   SAVED ON THIS DEVICE. Theme code cannot write to a customer's account, so
   signing in cannot carry a wishlist between devices.
*/
(function () {
    'use strict';

    var KEY = 'dico.wishlist.v1';
    var BEATS = [0, 60, 140, 260, 420, 650, 950];

    function read() {
        try {
            var raw = window.localStorage.getItem(KEY);
            var list = raw ? JSON.parse(raw) : [];
            return Array.isArray(list) ? list : [];
        } catch (e) { return []; }
    }

    function write(list) {
        try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
        syncHeart();
        renderList();
    }

    function has(id) {
        return read().some(function (i) { return String(i.id) === String(id); });
    }

    /* Ask the CDN for the size this slot needs. Saved items store a wide image
       because the wishlist PAGE renders it across a grid cell; this thumbnail is
       64px, so without rewriting the width the drawer would pull down a 1000px
       file - a second, needless download - to paint a stamp. */
    function sized(url, w) {
        if (!url) { return ''; }
        var u = String(url);
        if (u.indexOf('//') === 0) { u = 'https:' + u; }
        if (/[?&]width=\d+/.test(u)) {
            return u.replace(/([?&]width=)\d+/, '$1' + w);
        }
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    /* ---- the product on this page ---------------------------------------- */

    var DATA = null;
    function data() {
        if (DATA !== null) { return DATA; }
        var tag = document.querySelector('[data-dico-wl-product]');
        if (!tag) { DATA = false; return DATA; }
        try { DATA = JSON.parse(tag.textContent); } catch (e) { DATA = false; }
        return DATA;
    }

    function hasGrid() {
        return !!document.querySelector('.dsg-size');
    }

    /* The chosen variant. See the file header for why the grid wins. */
    function chosenId() {
        if (hasGrid()) {
            var picked = document.querySelector('.dsg-size[aria-pressed="true"]');
            return picked ? String(picked.getAttribute('data-variant-id') || '') : '';
        }
        var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        return input && input.value ? String(input.value) : '';
    }

    function variantOf(id) {
        var d = data();
        if (!d || !d.variants) { return null; }
        for (var i = 0; i < d.variants.length; i++) {
            if (String(d.variants[i].id) === String(id)) { return d.variants[i]; }
        }
        return null;
    }

    /* ---- the heart -------------------------------------------------------- */

    function makeHeart() {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dico-wl-heart';
        b.setAttribute('data-wl-heart', '');
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Save to wishlist');
        b.innerHTML = '<svg viewBox="0 0 20 18" aria-hidden="true" focusable="false">'
            + '<path d="M10 17S1 11.5 1 6.2A4.7 4.7 0 0 1 10 4a4.7 4.7 0 0 1 9 2.2C19 11.5 10 17 10 17z"'
            + ' fill="currentColor" fill-opacity="var(--dico-wl-fill, 0)"'
            + ' stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
        return b;
    }

    function onScreen(el) {
        return !!el && el.offsetParent !== null && el.getBoundingClientRect().height > 0;
    }

    /* The live call to action: Add to cart, or GET NOTIFIED when the size is
       sold out. Falls back to whichever exists so the heart is never homeless
       during the moment between the theme hiding one and the app showing the
       other. */
    function primaryButton() {
        var cart = document.querySelector('.cartButton');
        if (onScreen(cart)) { return cart; }
        var bis = document.getElementById('BIS_trigger');
        if (onScreen(bis)) { return bis; }
        return cart || bis || null;
    }

    /* Take apart any row that is no longer around the live button, putting its
       children back where they were. Without this the page keeps an empty
       20px box where a button used to be. */
    function tidyRows(keep) {
        var rows = document.querySelectorAll('.dico-wl-row');
        for (var i = 0; i < rows.length; i++) {
            var r = rows[i];
            if (r === keep || !r.parentNode) { continue; }
            while (r.firstChild) { r.parentNode.insertBefore(r.firstChild, r); }
            r.parentNode.removeChild(r);
        }
    }

    function mountHeart() {
        if (!data()) { return; }

        var target = primaryButton();
        if (!target || !target.parentNode) { return; }

        var heart = document.querySelector('[data-wl-heart]');
        var row = target.parentElement && target.parentElement.classList
                  && target.parentElement.classList.contains('dico-wl-row')
                ? target.parentElement
                : null;

        if (row && heart && heart.parentElement === row) {
            tidyRows(row);
            return;
        }

        if (!row) {
            row = document.createElement('div');
            row.className = 'dico-wl-row';
            target.parentNode.insertBefore(row, target);
            row.appendChild(target);
        }

        row.appendChild(heart || makeHeart());
        tidyRows(row);
    }

    /* The header heart: a number, and a filled icon once anything is saved.
       Runs everywhere, not just product pages. */
    function syncCount() {
        var n = read().length;
        var nums = document.querySelectorAll('[data-wl-count]');
        for (var i = 0; i < nums.length; i++) { nums[i].textContent = String(n); }
        var navs = document.querySelectorAll('[data-wl-nav], [data-wl-open]');
        for (var j = 0; j < navs.length; j++) {
            navs[j].setAttribute('data-wl-has', n ? 'yes' : 'no');
        }
    }

    /* Cheap: just the buttons' own state. Safe to run on a timer cascade. */
    function syncHeart() {
        syncCount();
        var id = chosenId();
        var on = id ? has(id) : false;
        var hearts = document.querySelectorAll('[data-wl-heart]');
        for (var i = 0; i < hearts.length; i++) {
            hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
            hearts[i].style.setProperty('--dico-wl-fill', on ? '1' : '0');
            hearts[i].setAttribute('aria-label', on ? 'Saved to wishlist' : 'Save to wishlist');
        }
    }

    function beat() {
        for (var i = 0; i < BEATS.length; i++) {
            window.setTimeout(function () { mountHeart(); syncHeart(); }, BEATS[i]);
        }
    }

    /* ---- the drawer ------------------------------------------------------- */

    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function renderList() {
        var root = document.querySelector('[data-dico-wl]');
        if (!root) { return; }
        var list = root.querySelector('[data-wl-list]');
        var foot = root.querySelector('[data-wl-foot]');
        if (!list) { return; }

        var items = read();
        if (!items.length) {
            list.innerHTML = '<li class="dico-wl-empty">Nothing saved yet</li>';
        } else {
            var out = '';
            for (var i = 0; i < items.length; i++) {
                var it = items[i];
                var thumb = sized(it.image, 200);
                out += '<li class="dico-wl-item" data-wl-id="' + esc(it.id) + '">'
                    +    (thumb
                            ? '<img class="dico-wl-thumb" src="' + esc(thumb) + '" alt="" loading="lazy">'
                            : '<span class="dico-wl-thumb"></span>')
                    +    '<div class="dico-wl-meta">'
                    +      '<a class="dico-wl-name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>'
                    +      '<span class="dico-wl-size">' + esc(it.size) + '</span>'
                    +      '<span class="dico-wl-price">' + esc(it.price) + '</span>'
                    +      (it.available === false ? '<span class="dico-wl-sold">Sold out</span>' : '')
                    +      '<button type="button" class="dico-wl-remove" data-wl-remove="' + esc(it.id) + '">Remove</button>'
                    +    '</div>'
                    +  '</li>';
            }
            list.innerHTML = out;
        }

        if (foot) {
            foot.innerHTML = items.length
                ? 'Saved on this device. <a href="/pages/wishlist">View wishlist</a>'
                : '';
        }

        syncCount();
    }

    function openPanel() {
        var root = document.querySelector('[data-dico-wl]');
        if (!root) { return; }
        renderList();
        root.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        var close = root.querySelector('.dico-wl-close');
        if (close) { close.focus({ preventScroll: true }); }
    }

    function closePanel() {
        var root = document.querySelector('[data-dico-wl]');
        if (!root) { return; }
        root.setAttribute('hidden', '');
        document.documentElement.style.overflow = '';
    }

    /* ---- actions ---------------------------------------------------------- */

    function nudgeSize() {
        var grid = document.querySelector('.dsg-size');
        var target = grid ? (grid.closest('[data-dsg]') || grid) : null;
        if (target && target.scrollIntoView) {
            target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    }

    function toggle() {
        var id = chosenId();
        var v = id ? variantOf(id) : null;

        /* No size chosen: do not guess. Saving an arbitrary size is the bug
           this whole file exists to avoid. */
        if (!v) { nudgeSize(); return; }

        var d = data();
        var list = read();
        var at = -1;
        for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(id)) { at = i; break; }
        }

        if (at > -1) {
            list.splice(at, 1);
            write(list);
            return;
        }

        list.unshift({
            id: String(v.id),
            title: d.title || d.fullTitle || '',
            size: v.title || '',
            price: v.price || '',
            image: v.image || '',
            available: v.available !== false,
            handle: d.handle || '',
            url: (d.url || '') + '?variant=' + encodeURIComponent(v.id),
            savedAt: Date.now()
        });
        write(list);
        openPanel();
    }

    /* ---- wiring ----------------------------------------------------------- */

    document.addEventListener('click', function (e) {
        var heart = e.target.closest('[data-wl-heart]');
        if (heart) { e.preventDefault(); toggle(); return; }

        var rm = e.target.closest('[data-wl-remove]');
        if (rm) {
            e.preventDefault();
            var id = rm.getAttribute('data-wl-remove');
            write(read().filter(function (i) { return String(i.id) !== String(id); }));
            return;
        }

        if (e.target.closest('[data-wl-close]')) { e.preventDefault(); closePanel(); return; }
        if (e.target.closest('[data-wl-open]')) { e.preventDefault(); openPanel(); return; }

        /* Anything else on a product page might have been a size change, which
           fires no event this script can listen for. Re-read a few times. */
        if (data()) { beat(); }
    }, true);

    document.addEventListener('change', function () { if (data()) { beat(); } }, true);

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closePanel(); }
    });

    /* Saving in one tab should show up in another. */
    window.addEventListener('storage', function (e) {
        if (e.key === KEY) { syncHeart(); renderList(); }
    });

    function boot() {
        mountHeart();
        syncHeart();
        renderList();

        /* The buy area is replaced wholesale on a size change, which destroys
           the heart. This puts it back; the timer cascade keeps its state honest. */
        var host = document.querySelector('product-content') || document.querySelector('main') || document.body;
        new MutationObserver(function () { mountHeart(); syncHeart(); })
            .observe(host, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
}());
